
import Vue, { PropType } from 'vue'
import { PublicPlace, ToiletType } from '@/models'

export default Vue.extend({
  name: 'WebsitePublicPlaceListItem',

  props: {
    publicPlace: Object as PropType<PublicPlace>
  },

  computed: {
    toiletTypeText(): string {
      switch (this.publicPlace?.toilet?.toiletType) {
        case ToiletType.FOR_MAN:
          return '男性トイレ'
        case ToiletType.FOR_WOMAN:
          return '女性トイレ'
        case ToiletType.UNISEX:
          return '共用'
        case ToiletType.MULTI_PURPOSE:
          return '多目的トイレ'
        default:
          return '不明'
      }
    },

    numOfBoxesText(): string {
      return String(this.publicPlace?.toilet?.boxesCount || 0)
    }
  }
})
